import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { CardDataKeys } from './types';

export interface CardDriver extends BaseUniDriver {
  isStacked(): Promise<boolean>;
}

export const cardDriverFactory = (base: UniDriver): CardDriver => {
  return {
    ...baseUniDriverFactory(base),
    async isStacked() {
      return (await base.attr(CardDataKeys.Stacked)) === 'true';
    },
  };
};
